import React from 'react';
import CommonDialog from './CommonDialog';


const AlertDialog = ({ showDialog, dialogId, title, body, onConfirm }) => {
    return (
        <CommonDialog
            show={showDialog}
            dialogId={dialogId}
            title={title}
            noCloseBtn={true}
            body={body}
            onConfirm={onConfirm}
            bodyClass='modal-body-center'
        />
    );
};

export default AlertDialog;